import { Button } from "@core/components/ui/button";
import { Input } from "@core/components/ui/Input";
import { useTheme } from "@core/hooks/useTheme";
import { cn } from "@core/lib/utils";
import { faSearch } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation, useNavigate, useSearchParams } from "@remix-run/react";
import { useState } from "react";


export const HeaderTextSearchFilter = () => {
  // const [searchParams, setSearchParams] = useSearchParams();
  // const location = useLocation();
  // const navigate = useNavigate();

  // const [searchValue, setSearchValue] = useState(searchParams.get("query") || "");

  // const c = useTheme("Header");

  // const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   setSearchValue(e.target.value);
  // };

  // const handleSearch = (e: React.FormEvent) => {
  //   e.preventDefault();

  //   setSearchParams((prev) => {
  //     const newParams = new URLSearchParams(prev);
  //     newParams.set("query", searchValue);
  //     return newParams;
  //   });

  //   if (!location.pathname.startsWith("/catalog")) {
  //     navigate(`/catalog?query=${encodeURIComponent(searchValue)}`);
  //   }
  // };

  return (
    <></>
    // <form onSubmit={handleSearch} className="relative w-full">
    //   <Input
    //     type="text"
    //     value={searchValue}
    //     onChange={handleInputChange}
    //     placeholder="Search..."
    //     {...c("HeaderTextSearchFilterInput", "")}
    //   />
    //   <Button
    //     type="submit"
    //     variant="ghost"
    //     {...c("HeaderTextSearchFilterButton", "absolute right-1 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700")}>
    //     <FontAwesomeIcon icon={faSearch} />
    //   </Button>
    // </form>
  );
};